// https://alligator.io/vuejs/global-event-bus/
import Vue from 'vue'
export default new Vue()

//* ******** Send Event ********/
// import EventBus from '@/d2admin/plugin/event/event-bus'
//
// export default {
//   data() {
//     return {
//       clickCount: 0
//     }
//   },
//
//   methods: {
//     emitGlobalClickEvent() {
//       this.clickCount++;
//       EventBus.$emit('i-got-clicked', this.clickCount);
//     }
//   }
// }

// * ******** Event Handler ********/
// import EventBus from '@/d2admin/plugin/event/event-bus'
//
// mounted() {
//   EventBus.$on('i-got-clicked', clickCount => {
//     console.log(`Oh, that's nice. It's gotten ${clickCount} clicks! :)`)
//   })
// }
//
// destroyed() {
//   EventBus.$off('i-got-clicked')
// }
